import { lazy } from 'react';
import { useRoutes } from 'react-router-dom';
import { TheLayout, TheContent } from '../containers';

import { routeKeyPath } from '../shared/utils/constants';
import { removeBackSlash } from '../shared/utils/helpers';

const Parents = lazy(() => import('../modules/Parents/Parents'));
const Students = lazy(() => import('../modules/Students/Students'));
const Teachers = lazy(() => import('../modules/Teachers/Teachers'));
const Home = lazy(() => import('../modules/Home/Home'));
const ContactUs = lazy(() => import('../modules/AboutUs/AboutUs'));
const Services = lazy(() => import('../modules/Services/Services'));
const AiTools = lazy(() => import('../modules/AiTools/AiTools'));


export default function Router() {
  const { aiLab, contactUs, forParents, forLearners, forTeachers, services } = routeKeyPath;

  return useRoutes([
    {
      path: '/',
      element: <TheLayout />,
      children: [
        {
          path: '',
          element: <TheContent />,
          children: [
            { path: removeBackSlash(contactUs), element: <ContactUs /> },
            { path: removeBackSlash(aiLab), element: <AiTools /> },
            { path: '', element: <Home /> },
            { path: removeBackSlash(forParents), element: <Parents /> },
            { path: removeBackSlash(forLearners), element: <Students /> },
            { path: removeBackSlash(services), element: <Services /> },
            { path: removeBackSlash(forTeachers), element: <Teachers /> },
          ],
        },
      ],
    },
  ]);
}
